import {
  TOGGLE_MIN_MAP,
  TOGGLE_CONTROLS,
  SET_VIEW_OPTIONS,
  TOOGLE_CANVAS_DIRECTION,
  SHOW_TOOLBOX_DETAILS,
  HIDE_TOOLBOX_DETAILS,
  SET_TOOLBOX_SELECTED_MENU_ITEM,
  CLEAR_TOOLBOX_SELECTED_MENU_ITEM
} from "redux/constants/flowDesigner";
import { SET_DESIGNER_SETTINGS } from "../../constants/flowDesigner";

export const toggleMinMap = () => ({
  type: TOGGLE_MIN_MAP
});
export const toggleControls = () => ({
  type: TOGGLE_CONTROLS
});

export const setViewOptions = (payload) => ({
  type: SET_VIEW_OPTIONS,
  payload
});
export const toggleCanvasDirection = () => ({
  type: TOOGLE_CANVAS_DIRECTION
});

export const openToolboxDetails = () => ({
  type: SHOW_TOOLBOX_DETAILS
});
export const closeToolboxDetails = () => ({
  type: HIDE_TOOLBOX_DETAILS
});
export const setToolboxSelectedMenuItem = (payload) => ({
  type: SET_TOOLBOX_SELECTED_MENU_ITEM,
  payload
});
export const clearToolboxSelectedMenuItem = () => ({
  type: CLEAR_TOOLBOX_SELECTED_MENU_ITEM
});
export const setDesignerSettings = (payload) => ({
  type: SET_DESIGNER_SETTINGS,
  payload
});
